
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { SingleCourseConent, SwiperCourseContent } from '@xt/client/types/home.d'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop() label: string
  @Prop() tabs: {
    key: number
    label: string
    content: SingleCourseConent | SwiperCourseContent
  }[]

  @Ref()
  tabActive: HTMLDivElement

  activeIndex: number = 0

  clickDisable(index) {
    return this.tabs[index].content.list.length === 0
  }

  changeTabs(index) {
    if (this.activeIndex === index) return

    // 当前点击tabs的list为空时不跳转
    if (this.tabs[index].content.list.length === 0) {
      this.$msg('敬请期待～', 'info')
      return
    }

    let offset = this.tabActive.offsetLeft // 获取 activeTabs 的left值

    if (this.activeIndex > index) {
      for (let i = this.activeIndex - 1; i >= index; i--) {
        offset = offset - Math.floor(this.$refs[`tab-${i}`]![0].offsetWidth) - 8
      }
    } else {
      for (let i = this.activeIndex; i < index; i++) {
        offset = offset + Math.floor(this.$refs[`tab-${i}`]![0].offsetWidth) + 8
      }
    }

    this.tabActive.style.left = `${offset}px`

    this.activeIndex = index

    this.$emit('changeTabs', index)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
